<template>
    <div>
        <div class="flex items-center justify-between">
            <p v-if="label != null" class="text-14 text-grey-900 pb-1">
                {{ label }}
            </p>

            <button
                v-if="canClear && !cleared"
                class="flex items-center icon-hover text-grey-900 text-14"
                type="button"
                @click="
                    () => {
                        clear('')
                        cleared = true
                    }
                "
            >
                <p class="pr-1">Clear</p>
                <IconClose class="w-4 h-4" />
            </button>
        </div>

        <div :class="[boxClass, [error ? 'border-error' : 'border-grey-500']]" class="input-group min-h-12 !items-start relative">
            <slot name="left" />

            <textarea
                :name="name"
                :placeholder="$help.capitalizeFirstLetter(placeholder)"
                :rows="rows"
                :type="type"
                :value="value"
                :disabled="disabled"
                autocomplete="off"
                class="bg-transparent px-3 disabled:bg-transparent disabled:text-grey-700 transition-all w-full h-full placeholder-grey-900 text-black autofill:bg-transparent autofill:bg-none autofill:placeholder-grey-900 autofill:shadow-transparent outline-0 py-2 text-15"
                @input="update"
                :class="{
                    'pr-14': ai[aiKey] != null,
                }"
            />

            <p
                v-if="limit !== null"
                class="text-grey-900 text-12 text-right absolute bottom-0 right-0 left-0 px-4 py-2 z-[0] bg-grey"
                :class="{
                    'text-red-700': value.length > limit,
                }"
            >
                <slot name="limit" :value="value" :length="value.length" :limit="limit" />

                <template v-if="!$slots.limit">{{ value != null ? value.length : 0 }} / {{ limit }}</template>
            </p>

            <tippy :offset="[2, 4]" maxWidth="100%" placement="bottom-end" class="w-12 h-12 absolute top-0 right-0" v-if="ai[aiKey] != null">
                <button
                    class="w-12 h-12 flex items-center justify-center"
                    type="button"
                    @click="setAIValue(ai[aiKey])"
                >
                    <IconZap class="stroke-grey-800" />
                </button>

                <template #content>
                    <p>Generated by <b>Zap</b> your AI assistant</p>
                </template>
            </tippy>

            <!-- @keyup='$emit("update:value", value)' -->

            <slot name="right" />
        </div>

        <div
            v-show="error != false"
            :class="[error == false ? 'opacity-0' : '']"
            class="pt-2 flex items-center error transition-all duration-300"
        >
            <IconFalse class="w-5 h-5 stroke-red-700 bg-red-700 rounded-full bg-opacity-10 mr-2" />

            <p class="error text-error text-14">{{ error }}</p>
        </div>
    </div>
</template>

<script>
import Input from '~/mixins/input.js'

export default {
    mixins: [Input],

    props: {
        rows: String,
        canClear: { type: Boolean, default: false },
    },

    data() {
        return {
            cleared: this.value == '' ? true : false,
        }
    },
}
</script>
